import { Dropdown, Menu, Button } from "antd";
import {
  MoreOutlined,
  UploadOutlined,
  FileSearchOutlined,
  EyeOutlined,
  PullRequestOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { reverse } from "named-urls";
import routes from "../../../../../../routes";
import { useState } from "react";
import RaiseCorrectionRequest from "../../../../../components/RaiseCorrectionRequest";
import ViewCorrection from "../../../../../components/ViewCorrection";

function ReviewReportsAction({ record, userRole, fetchReports }) {
  const history = useHistory();
  const [openRaiseCorrectionModal, setOpenRaiseCorrectionModal] =
    useState(false);
  const [openViewCorrectionModal, setOpenViewCorrectionModal] = useState(false);

  const handleReupload = () => {
    history.push(
      reverse(`${routes.labs.orders.details.reuploadReport}`, {
        orderId: record.id,
      })
    );
  };

  const handleReview = (record) => {
    history.push(
      reverse(routes.labs.reviewReports.review, {
        id: record.orderId,
      }),
      {
        _id: record.id
      }
    );
  };

  const menu = (
    <Menu>
      {record?.parsingReviewStatus !== "ProcessingFailed" ? (
        <Menu.Item
          key="review"
          icon={<FileSearchOutlined />}
          onClick={() => handleReview(record)}
        >
          Review Report
        </Menu.Item>
      ) : (
        <></>
      )}

      {record?.parsingReviewStatus !== "ReviewCompleted" &&
      (userRole === "lab_admin") ? (
        <Menu.Item
          key="reupload"
          icon={<UploadOutlined />}
          onClick={handleReupload}
        >
          Re-upload Report
        </Menu.Item>
      ) : (
        <></>
      )}

      {record?.parsingReviewStatus !== "ReviewCompleted" &&
      userRole !== "lab_admin" && userRole !== "support_team" && userRole !== "csc_admin" ? (
        <Menu.Item
          key="raised-correction"
          icon={<PullRequestOutlined />}
          onClick={() => setOpenRaiseCorrectionModal(true)}
        >
          Raise Correction
        </Menu.Item>
      ) : (
        <></>
      )}

      <Menu.Item
        key="view-correction-request"
        icon={<EyeOutlined />}
        onClick={() => setOpenViewCorrectionModal(true)}
      >
        View Correction Request
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menu} trigger={["click"]} placement="bottomLeft">
        <Button type="text" shape="circle" icon={<MoreOutlined />} />
      </Dropdown>
      {openRaiseCorrectionModal && (
        <RaiseCorrectionRequest
          id={record.id}
          orderId={record.orderId}
          onOpen={openRaiseCorrectionModal}
          onClose={() => setOpenRaiseCorrectionModal(false)}
          fetchUpdatedData={fetchReports}
        />
      )}
      {openViewCorrectionModal && (
        <ViewCorrection
          id={record.id}
          orderId={record.orderId}
          onOpen={openViewCorrectionModal}
          onClose={() => setOpenViewCorrectionModal(false)}
        />
      )}
    </>
  );
}

export default ReviewReportsAction;
